__webpack_require__.p = "/as-admin-ui/";